'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { ImageSlider, type SliderImage } from '@7f-ui/components/image-slider/image-slider';
import { useIsHydrated } from '@7f-ui/hooks/use-is-hydrated';
import Image from 'next/image';
type AppAccommodationRoomImageSliderProps = {
  images: SliderImage[];
  className?: string;
};
export function AppAccommodationRoomImageSlider(t0) {
  const $ = _c(12);
  const {
    images,
    className
  } = t0;
  const isHydrated = useIsHydrated();
  if (!isHydrated) {
    const previewImage = images[0];
    if (!previewImage) {
      return null;
    }
    let t1;
    if ($[0] !== className) {
      t1 = cx("relative", className);
      $[0] = className;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = previewImage.alt ?? "";
    const t3 = previewImage.sizes ?? "(max-width: 768px) 80vw,1000px";
    let t4;
    if ($[2] !== previewImage.url || $[3] !== t2 || $[4] !== t3) {
      t4 = <Image fill={true} className="object-cover" src={previewImage.url} alt={t2} sizes={t3} priority={true} />;
      $[2] = previewImage.url;
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t1 || $[7] !== t4) {
      t5 = <div className={t1}>{t4}</div>;
      $[6] = t1;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t1;
  if ($[9] !== className || $[10] !== images) {
    t1 = <ImageSlider className={className} images={images} />;
    $[9] = className;
    $[10] = images;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}